export const BRAND_NAME = 'Fravai'
export const BRAND_TAGLINE = 'Начните автоматизировать контент уже сейчас'
export const BRAND_SUBLINE = 'AI визуал-студия'

export const LOGO_URL = new URL('./logo.svg', import.meta.url).href
export const LOGO_URL_WHITE = new URL('./logo_white.svg', import.meta.url).href

